module.exports = __webpack_public_path__ + "img/flex5.3abda8bd.gif";